import styled from '@emotion/styled';

export const DaftarProgresStyle = styled.div`
  @media (min-width: 481px) and (max-width: 767px) {
    .btn-detail {
      top: 0% !important;
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {   
    .btn-detail {
      top: 0% !important;
    }
  }

  .btn-detail {
    background-color: #24A0ED;
    position: absolute;
    right: 0;
    top: -10%;
  }

  .container-list {
    max-width: 1400px;
    margin-top : 3%;
  }

  .status-header {
    align-items: center;
    justify-content: center;
    box-shadow: none;
    border-radius: 0px;
    width: 25%
  }

  .chosen-status {
      font-weight: bold;
      border-bottom: 3px solid #373736;
  }
`;
